import { DateSchema } from '@racemap/sdk/schema/base';
import { z } from 'zod';
import { EventLoadTypes } from '../events';
import { BillableItemTypes } from '../user';
import { UserCreditSchema } from '../userCredits';
import { DailyLoadsSchema } from './dailyLoads';
import { EventStatisticsSchema } from './eventStatistics';
import { TaxBreakdownSchema } from './taxBreakedown';
import { TotalUsagesSchema } from './totalUsages';

const UsageGroupedByTimeKeyAndZoneSchema = z.record(
  z.string(),
  z.object({
    [BillableItemTypes.DATA_USAGE_ZONE_1]: z.number().optional(),
    [BillableItemTypes.DATA_USAGE_ZONE_1_V6_SIM]: z.number().optional(),
    [BillableItemTypes.DATA_USAGE_ZONE_2]: z.number().optional(),
    [BillableItemTypes.DATA_USAGE_ZONE_2_V6_SIM]: z.number().optional(),
    [BillableItemTypes.DATA_USAGE_ZONE_3]: z.number().optional(),
    [BillableItemTypes.DATA_USAGE_ZONE_3_V6_SIM]: z.number().optional(),
  }),
);

export const BillingInfoSchema = z.object({
  dailyLoads: DailyLoadsSchema,
  eventStatistics: EventStatisticsSchema,
  totals: TotalUsagesSchema,
  totalLoadCounts: z.record(z.enum(EventLoadTypes), z.number()),
  totalAmount: z.number().optional(),
  totalAmountTax: z.number().optional(),
  taxBreakdowns: TaxBreakdownSchema.optional(),
  // set instead of totalAmount when Stripe could not calculate the tax
  taxError: z.enum(['address', 'no_shipping_address', 'unavailable']).optional(),
  startTime: DateSchema,
  endTime: DateSchema,
  dataUsages: UsageGroupedByTimeKeyAndZoneSchema,
  userCredits: z.array(UserCreditSchema).default([]),
});

export type BillingInfo = z.infer<typeof BillingInfoSchema>;
